import { z } from "zod";
const id = z.string().trim().min(1).max(200);
const sha256 = z.string().regex(/^[0-9a-f]{64}$/u);
export const twinLogicExecutionAuthoritySchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("production"),
        activationEventId: id,
        activatedAt: z.number().int().positive().safe(),
    }).strict(),
    z.object({
        kind: z.literal("candidate"),
        buildId: z.string().regex(/^twin_cbuild_[0-9a-f]{32}$/u),
        catalogSha256: sha256,
        evidenceCutId: z.string().regex(/^ecut_[0-9a-f]{64}$/u),
        evidenceCutManifestSha256: sha256,
        candidateReleaseSha: z.string().regex(/^[0-9a-f]{40}$/u),
        servingOperationId: id,
        servingReceiptSha256: sha256,
    }).strict(),
]);
const queryAuthority = {
    semanticSelectionMethod: z.enum(["explicit_pin", "deterministic_match", "model_selected"]),
    warehouseOrganisationId: id,
    productVersionSha256: sha256,
    installationId: id,
    authoringRequestSha256: sha256,
    sourceProjectionSha256: sha256,
    verifiedAuthoringReleaseSha256: sha256,
    acceptedDecisionSha256: sha256,
    automatedAuthoringClosureSha256: sha256,
    semanticMemberLedgerSha256: sha256,
};
export const twinLogicQueryAuthoritySchema = z.object({
    ...queryAuthority,
    executionAuthority: twinLogicExecutionAuthoritySchema,
}).strict();
// Saved certificates and overlays preserve their original bytes. This reader
// never manufactures an execution lane or an activation timestamp.
export const archivedTwinLogicQueryAuthoritySchema = z.union([
    twinLogicQueryAuthoritySchema,
    z.object({
        semanticSelectionMethod: queryAuthority.semanticSelectionMethod,
        warehouseOrganisationId: queryAuthority.warehouseOrganisationId,
        productVersionSha256: queryAuthority.productVersionSha256,
        activationEventId: id,
        installationId: queryAuthority.installationId,
        authoringRequestSha256: queryAuthority.authoringRequestSha256,
        sourceProjectionSha256: queryAuthority.sourceProjectionSha256,
        verifiedAuthoringReleaseSha256: queryAuthority.verifiedAuthoringReleaseSha256,
        acceptedDecisionSha256: queryAuthority.acceptedDecisionSha256,
        automatedAuthoringClosureSha256: queryAuthority.automatedAuthoringClosureSha256,
        semanticMemberLedgerSha256: queryAuthority.semanticMemberLedgerSha256,
    }).strict(),
]);
export function requireCurrentTwinLogicQueryAuthority(value) {
    const parsed = twinLogicQueryAuthoritySchema.safeParse(value);
    if (!parsed.success)
        throw new Error("twin_logic_current_execution_authority_required");
    return parsed.data;
}
